import { ResourceType } from '../../shared/resource-type';


export const METADATA_SECURITY_TYPE = new ResourceType('securitysetting');
